import { SUPPORTED_COUNTRY_CODES } from '@app/countries/consts';

const isValidCountryCode = (countryCode: string) =>
  SUPPORTED_COUNTRY_CODES.has(countryCode);

export default isValidCountryCode;
